import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "p-g01-item-list" }
const _hoisted_2 = { class: "p-g01-item-list__list" }
const _hoisted_3 = {
  key: 0,
  class: "p-g01-item-list__list__wrap__panel"
}
const _hoisted_4 = {
  key: 0,
  class: "p-g01-item-list__more"
}
const _hoisted_5 = {
  key: 1,
  class: "p-g01-item-list__more__button"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_G01IconRanking = _resolveComponent("G01IconRanking")!
  const _component_ItemListPanel = _resolveComponent("ItemListPanel")!
  const _component_IconArrowBottom = _resolveComponent("IconArrowBottom")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_ButtonMain = _resolveComponent("ButtonMain")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, key) => {
        return (_openBlock(), _createElementBlock("div", {
          key: key,
          class: "p-g01-item-list__list__wrap"
        }, [
          (_ctx.current(key) <= _ctx.max)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_G01IconRanking, {
                  num: _ctx.current(key),
                  class: "p-g01-item-list__ranking_icon"
                }, null, 8, ["num"]),
                _createElementVNode("div", null, [
                  _createVNode(_component_ItemListPanel, {
                    id: item.id,
                    "img-path": _ctx.getImagePath(item.premium),
                    name: item.premium.name,
                    point: item.premium.point_required,
                    "discount-rate": 0,
                    color: _ctx.getColor(item.quantity),
                    "is-favorite": item.premium.is_featured,
                    status: item.premium.is_new,
                    stock: item.quantity,
                    "stock-control": item.is_quantity_control
                  }, null, 8, ["id", "img-path", "name", "point", "color", "is-favorite", "status", "stock", "stock-control"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    (_ctx.items.length > 4)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (!_ctx.isAll)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: "javascript:void(0);",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showAll && _ctx.showAll(...args))),
                class: "p-g01-item-list__more__link",
                style: _normalizeStyle({ color: _ctx.colorCode })
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.items.length) + "位までみる", 1),
                _createVNode(_component_IconBase, {
                  "view-box": "0 0 24 24",
                  width: "24",
                  height: "24",
                  "icon-color": _ctx.colorCode,
                  class: "p-g01-item-list__more__link__icon"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconArrowBottom)
                  ]),
                  _: 1
                }, 8, ["icon-color"])
              ], 4))
            : _createCommentVNode("", true),
          (_ctx.isCategory)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_ButtonMain, {
                  tag: 'a',
                  href: "/b01/",
                  kind: "secondary"
                }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode("このカテゴリーの商品をもっと見る", -1)
                  ])),
                  _: 1,
                  __: [1]
                })
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}